import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const CFoodCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  width: 100%;
  border-bottom: 1px dashed ${Color.grey999};
  ${breakpoints.phone} {
    min-height: 52px;
  }
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      border-bottom: 1px dashed ${ColorDark.greySeparator};
    }
  }
  &.borderNone {
    border-bottom: 0px;
    ${breakpoints.phone} {
      border-bottom: 1px dashed ${Color.grey999};
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          border-bottom: 1px dashed ${ColorDark.greySeparator};
        }
      }
    }
  }
  &.foodCardColumn {
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    //height: fit-content;
    > div:first-of-type {
      min-height: 60px !important;
    }
    ${breakpoints.phone} {
      flex-direction: row;
    }
  }
  .food-card {
    &__rating {
      ${breakpoints.tablet} {
        margin-right: 0.35rem;
      }
    }
    &__info {
      display: flex;
      align-items: center;
      gap: 14px;
      max-width: 100%;
      ${breakpoints.tablet} {
        gap: 0.35rem;
      }
    }
    &__badge {
      max-width: min-content;
      background-color: ${Color.yellow2};
      border-radius: 5px;
      height: 27px;
      min-height: fit-content;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.4rem;
      text-transform: uppercase;
      white-space: nowrap;

      span {
        ${Font.sansSemiBold};
        font-size: 13px;
        line-height: 27px;
        letter-spacing: 0.2px;
        ${breakpoints.tablet} {
          font-size: 10px;
          line-height: 12px;
        }
      }
      ${breakpoints.tablet} {
        padding: 0.25rem 0.35rem;
      }
    }
    &__time {
      ${Font.sansRegular};
      color: ${Color.grey};
      font-size: 13px;
      line-height: 25px;
      white-space: nowrap;

      ${breakpoints.tablet} {
        white-space: nowrap;
        font-size: 11px;
        line-height: 12px;
      }
    }
    &__btnSaveCollection {
      ${breakpoints.tablet} {
        width: 26px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .food-card__options {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    ${breakpoints.tablet} {
      gap: unset;
    }
  }
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      .food-card__rating {
        filter: invert(70%);
      }
      .food-card__time {
        color: ${ColorDark.textLight};
      }
    }
  }
`;
export const StarList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.2rem;
  span.filled svg {
    fill: ${Color.grey};
  }
  span.empty svg {
    fill: ${Color.greyE2E2E2};
  }
  span.active svg {
    fill: ${Color.grey};
  }
`;
